<template>
	<div>
		<div style="padding: 0 260px 50px;">
			<div class="nodea" v-if="count.length == 0">
				<img src="../../../../assets/img/nodata.png" >
			</div>
			<div class="list_box p_b_b small_hand" v-for="(item, index) in count" @click="goDeatil(item.id,item.job_type)" :key="index" infinite-scroll-disabled="disabled">
				<span class="type_size_22">{{ item.name }}</span>
				<div class="p_flex p_f_a p_f_b p_m_t_20 type_size_16">
					<div class="p_flex ">
						<span class="subject_color">{{ item.classLevel.name }}</span>
						<el-divider direction="vertical"></el-divider>
						<span class="subject_yellow">{{ item.subject_def }}</span>
						<el-divider direction="vertical"></el-divider>
						<span>{{ item.question_count }}道题</span>
						<el-divider direction="vertical"></el-divider>
						<span>{{ item.score }}分</span>
					</div>
				</div>
				<div class="p_flex p_f_a p_f_b p_m_t_20 type_size_16">
					<div class="p_flex ">参与人数</div>
					<div class="p_f_1 p_m_l_20  p_m_r_20">
						<el-progress
							:text-inside="true"
							:show-text="false"
							color="#00AF63"
							:stroke-width="20"
							:percentage="item.already_submit == item.should_submit ? 100 : (item.already_submit / item.should_submit) * 100"
							status="success"
						></el-progress>
					</div>
					<span>{{ item.already_submit }}/{{ item.should_submit }}</span>
				</div>
				<div class="p_flex p_f_a p_f_b p_m_t_20 type_size_16">
					<div class="p_flex ">提交时间 {{ item.create_date }} 至 {{ item.submit_date }}</div>
					<div class="p_flex"><el-button @click.stop="goDeatils(item.id)" type="success" size="mini">作业分析报告</el-button></div>
				</div>
			</div>
		</div>
		<pagination @get="get" :index="num" />
	</div>
</template>

<script>
import pagination from '../../../pagination/pagination.vue';
export default {
	data() {
		return {
			count: [],
			loading: false,
			num: 0
		};
	},
	components: {
		pagination
	},
	mounted() {
		this.get();
	},
	methods: {
		get(id) {
			// console.log(id)
			this.$request
				.ajax(this)
				.post('/api_teacher/job_correcting_list', {
					corrects: 1, //1.已批改，2.待批改
					page: id ? id : 1, //第几页
					limit: 10 //，每页显示
				})
				.then(res => {
					// console.log(res)
					this.num = parseInt(res.data.count);
					this.count = res.data.list;
				});
		},
		goDeatils(id) {
			this.$router.push({
				path: '/AnalyseDeatil',
				query: {
					id: id
				}
			});
		},
		goDeatil(id,type) {
			if( type == 2 ){
				this.$router.push({
					path: '/SentSheet',
					query: {
						id: id,
						type: type,
						i:1
					}
				});
			}else{
				this.$router.push({
					path: '/PerformDeatil',
					query: {
						id: id
					}
				});
			}

		}
	}
};
</script>
<style lang="scss" scoped>
@import '../../../../assets/css/list.css';
</style>



// WEBPACK FOOTER //
// src/components/homet/perform/commponents/performList.vue